import React from 'react';
import { apiGetFamilyTree, apiIsLoggedIn } from '../api/api';
import '../styles/familytree.css';
import TopBarMain from '../components/topbars/TopBarMain';
import * as f3 from 'family-chart';
import 'family-chart/styles/family-chart.css';
class FamilyTreePage extends React.Component {
    constructor(props) {
        super(props);
    }
    
    async componentDidMount() {
        const isLoggedIn = await apiIsLoggedIn()
        if (!isLoggedIn) {
            window.location.href = '/';
        }

        const data = [];
        const familyTreeResponse = await apiGetFamilyTree();
        if (!familyTreeResponse.ok) {
            return;
        }

        const familyTreeData = await familyTreeResponse.json();
        
        familyTreeData['tree'].forEach(element => {
            if (element.id === "eustache-i-de-neufville-1047") {
                data.unshift({
                    id: element.id,
                    data: {
                        "first name": element["first name"],
                        "last name": element["last name"],
                        birthday: element.birthday,
                        gender: element.gender,
                    },
                    rels: {
                        spouses: element.spouses,
                        children: element.children,
                        parents: element.parents,
                    },
                })
            } else {
                data.push({
                    id: element.id,
                    data: {
                        "first name": element["first name"],
                        "last name": element["last name"],
                        birthday: element.birthday,
                        gender: element.gender,
                    },
                    rels: {
                        spouses: element.spouses,
                        children: element.children,
                        parents: element.parents,
                    },
                })
            }
        });

        const f3Chart = f3.createChart('#FamilyChart', data);

        f3Chart.setCardHtml()
            .setCardDisplay([["first name", "last name"],["birthday"]]);

        f3Chart.updateTree({initial: true});
    }

    render() {
        return (
            <div>
                <TopBarMain />
                <div className='family-tree-page'>
                    <h2>Family Tree</h2>
                    <p>More coming soon! Please email <a href="mailto:ramsey.opp@gmail.com">ramsey.opp@gmail.com</a> if you have any information to help.</p>
                    <div className="f3" id="FamilyChart" style={{width: '100%', height: '900px', margin: 'auto', backgroundColor: 'rgba(33,33,33, .75)', color: '#fff'}} />
                </div>
            </div>
        );
    }
}

export default FamilyTreePage;
